import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonService } from 'src/app/common.service';
import { SendResetPasswordEmailRequest } from 'auth-api'; 

@Component({
  selector: 'app-lost-password',
  templateUrl: './lost-password.component.html',
  styleUrls: ['./lost-password.component.css']
})

export class LostPasswordComponent implements OnInit {
  static EMAIL_REGEXP_VALIDATOR = new RegExp("[A-z0-9\.\+_-]+@[A-z0-9\._-]+\.[A-z]{2,6}");
  done = false;
  loading = false;
  error = 'no_error';
  lostPasswordForm = new FormGroup({
    loginUsername: new FormControl('', [Validators.required, Validators.email, Validators.pattern(LostPasswordComponent.EMAIL_REGEXP_VALIDATOR)])
  });
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService
  ) { }

  ngOnInit() {
  }

  lostPasswordSubmitHandler() {
    this.loading = true;
    this.resetError();
    if (!this.lostPasswordForm.valid) {
      this.error = "I campi non sono compilati correttamente";
      const controls = this.lostPasswordForm.controls;
      Object.keys(controls).forEach(controlName => controls[controlName].markAsDirty());
      console.log("Invalid Form");
      this.loading = false;
      return;
    }

    let sendResetPasswordEmailRequest: SendResetPasswordEmailRequest = {
      email: this.lostPasswordForm.value.loginUsername
    }

    this.commonService.getRegistrationService().authSendResetPasswordEmailPost(sendResetPasswordEmailRequest).subscribe(
      (data) => {
        this.done = true;
        console.log(data);
      },
      error => {
        this.error = "Qualcosa non ha funzionato";
        console.log(error);
      }
    );

    console.log("Login submit");
    this.loading = false;
  }

  resetError() {
    this.error = 'no_error';
  }
}
